require("../js/webformscompat");
global.eduutils = require("../js/eduutils");
global.luvitedu = require("../js/edu_frameset.js");
global.LMSAPI = require("../../Education/SCORM/LMSAPI");
global.LMSAPI2004 = require("../../Education/SCORM/LMSAPI2004");
global.sanitizer = require("../js/lib/sanitizer");
import "../../../../node_modules/jquery-ui-dist/jquery-ui";
require("../js/plugins/jquery.touchSwipe.min.js");
require("../js/plugins");
require("../js/lib/features");
// force load ckeditor on all webforms pages.
let ckeditorConfig = require("../js/config/ckeditor-config");
require("../../ckeditor45/ckeditor.js");
ckeditorConfig.setup();
const {
  hasLowerCase,
  hasUpperCase,
  hasNumber,
  hasSpecialCharacter,
} = require("../js/lib/utils.js");
var passPolicy = {};
passPolicy.hasUpperCase = hasUpperCase;
passPolicy.hasLowerCase = hasLowerCase;
passPolicy.hasNumber = hasNumber;
passPolicy.hasSpecialCharacter = hasSpecialCharacter;
global.passPolicy = passPolicy;
